export const downloadTickets = (order: wix.events.ticketing.Order) => window.open(order.ticketsPdf)

export const downloadTicket = (ticket: wix.events.ticketing.Ticket) => window.open(ticket.ticketPdf)

export const downloadTicketsWithNoOrder = (tickets: wix.events.ticketing.Ticket[]) => tickets.forEach(downloadTicket)
